import React from 'react'
import { gql } from '@apollo/client'

import p from 'prop-types'
import { Mutation } from '@apollo/client/react/components'
import { fieldErrors, nonFieldErrors } from '../util/errutil'

import FormDialog from '../dialogs/FormDialog'
import UserNotificationRuleForm from './UserNotificationRuleForm'

const createMutation = gql`
  mutation($input: CreateUserNotificationRuleInput!) {
    createUserNotificationRule(input: $input) {
      id
    }
  }
`

export default class UserNotificationRuleCreateDialog extends React.PureComponent {
  static propTypes = {
    userID: p.string.isRequired,
    onClose: p.func,
  }

  state = {
    value: {
      contactMethodID: '',
      delayMinutes: '0',
    },
    errors: [],
  }

  render() {
    return (
      <Mutation mutation={createMutation} onCompleted={this.props.onClose}>
        {(commit, status) => this.renderDialog(commit, status)}
      </Mutation>
    )
  }

  renderDialog(commit, status) {
    const { loading, error } = status
    const fieldErrs = fieldErrors(error)

    return (
      <FormDialog
        title='Create New Notification Rule'
        loading={loading}
        errors={nonFieldErrors(error)}
        onClose={this.props.onClose}
        onSubmit={() => {
          return commit({
            variables: {
              input: { ...this.state.value, userID: this.props.userID },
            },
          })
        }}
        form={
          <UserNotificationRuleForm
            userID={this.props.userID}
            errors={fieldErrs}
            disabled={loading}
            value={this.state.value}
            onChange={(value) => this.setState({ value })}
          />
        }
      />
    )
  }
}
